import * as THREE from 'three'
import React from 'react'
import { extend, useFrame, useThree } from 'react-three-fiber'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { isMobile } from './../../../utils'

const FOV = window.innerWidth < 600 ? 90 : 60
const SPEED = -0.3
const AUTO_ROTATE_SPEED = 0.3
extend({ OrbitControls })

const VRControls = React.memo(({ initialPosition, initialCompass = 0, autoRotate }) => {
    const mounted = React.useRef()
    const orbitRef = React.useRef()
    const { gl, camera } = useThree()
    useFrame(() => updateCamera())

    if (orbitRef.current && mounted.current !== true) {
        window.controls = orbitRef.current;
        window.gl = gl;
        camera.fov = FOV;

        gl.setSize(window.innerWidth, window.innerHeight, false);
        camera.updateProjectionMatrix();
    }

    const updateCamera = () => {
        if (!window.controls) window.controls = orbitRef.current;
        if (!window.gl) window.gl = gl;
        orbitRef.current && orbitRef.current.update();
        camera.updateProjectionMatrix();
        
        if (!window.compass) return;
        const dir = camera.getWorldDirection(new THREE.Vector3())
        const sph = new THREE.Spherical().setFromVector3(dir)
        
        const currentAngle = THREE.Math.radToDeg(sph.theta);
        const positionAngle = THREE.Math.radToDeg(initialPosition[0] / (100 * Math.PI));
        const rotateZ = initialCompass[2] ?? 0;
        const angle = currentAngle + positionAngle + rotateZ - 90;
        const newTransform = `rotate(${-angle.toFixed(0)}deg)`;
        if (window.compass.style && window.compass.style?.transform !== newTransform) {
            window.compass.style.transform = newTransform;
        }

        if (window.compass2?.style && window.compass2?.style?.transform !== newTransform) {
            window.compass2.style.transform = newTransform;
        }
        
        
        window.angle =  currentAngle;
    }

    return (<orbitControls
        ref={orbitRef}
        args={[camera, gl.domElement]}
        maxPolarAngle={5}
        minPolarAngle={0}
        minDistance={FOV}
        maxDistance={FOV}
        enableKeys={true}
        enableZoom={isMobile()}
        enablePan={false}
        enableDamping={false}
        dampingFactor={0.06}
        autoRotate={autoRotate}
        rotateSpeed={SPEED}
        autoRotateSpeed={AUTO_ROTATE_SPEED}
    />)
})

export default VRControls